import Layouts from "../../helpers/Layouts";
import PrivacyPolicySection from "./PrivacyPolicySection";

export default function PrivacyOne() {
    return (
        <>
            <Layouts
                pageTitle="Privacy Policy"
                breadcrumbs={[
                    {name: "home", path: "/"},
                    {name: "privacy", path: "/privacy"},
                ]}
            >
                <PrivacyPolicySection className="pb-240"/>
            </Layouts>
        </>
    );
}
